"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = ResourceLoading;

var _react = require("@chakra-ui/react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsxRuntime = require("react/jsx-runtime");

// deps
function ResourceLoading(props) {
  const {
    label,
    ...otherProps
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    ...otherProps,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Spinner, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Stack, {
      marginTop: "0.625rem"
    }), label && label]
  });
}

ResourceLoading.propTypes = {
  label: _propTypes.default.string
};